export const DEFAULT_FILTERS = {
  contractNumber: '',
  subscriberName: '',
  status: 'all',
};

export const STATUS_OPTIONS = [
  { label: 'Todas', value: 'all' },
  { label: 'No leídas', value: 'unread' },
  { label: 'Leídas', value: 'read' },
];
